__webpack_require__.p = "https://jumuishi.ncpdsmz.go.tz/";